import React, {useEffect, useState} from "react";
import axios from "axios";
import "./ObbTvHaberPage.scss";

const ObbTvHaberPage = () => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selected, setSelected] = useState(null); // seçili video

    useEffect(() => {
        let mounted = true;
        const fetchData = async () => {
            try {
                setLoading(true);
                const res = await axios.get("https://obbtv.com/ytbot/shorts.php");
                if (!mounted) return;
                setItems(res.data?.results || []);
            } catch (err) {
                console.error(err);
                if (!mounted) return;
                setError("Veri yüklenirken hata oluştu.");
            } finally {
                if (mounted) setLoading(false);
            }
        };
        fetchData();
        return () => {
            mounted = false;
        };
    }, []);

    useEffect(() => {
        const onKey = (e) => {
            if (e.key === 'Escape') closePlayer();
        };
        if (selected) window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [selected]);

    const openPlayer = (item) => {
        setSelected(item);
        // arkaplan kaydırmayı engelle
        try { document.body.style.overflow = 'hidden'; } catch (e) { }
    };
    const closePlayer = () => {
        setSelected(null);
        try { document.body.style.overflow = ''; } catch (e) { }
    };

    const getThumbnail = (item) => {
        return item?.thumbnail || (item?.id ? `https://i.ytimg.com/vi/${item.id}/hqdefault.jpg` : "");
    };

    const getUrl = (item) => {
        return item?.link || (item?.id ? `https://youtu.be/${item.id}` : "#");
    };

    const getVideoId = (item) => {
        if (!item) return null;
        if (item.id) return item.id;
        const link = item.link || item.url || '';
        try {
            const u = new URL(link);
            // youtube.com/watch?v=XXX
            if (u.searchParams.get('v')) return u.searchParams.get('v');
            // youtu.be/ID or /shorts/ID or /embed/ID
            const parts = u.pathname.split('/').filter(Boolean);
            if (parts.length) return parts[parts.length - 1];
        } catch (e) {
            // fallback: try to extract last segment
            const seg = link.split('/').filter(Boolean).pop();
            return seg || null;
        }
        return null;
    };

    const getEmbedUrl = (item) => {
        const id = getVideoId(item);
        return id ? `https://www.youtube.com/embed/${id}?rel=0&autoplay=1&playsinline=1` : '';
    };

    const handleClick = (e, item) => {
        // Ctrl/Meta/Shift ile yeni sekmede açılmak isteniyorsa varsayılan davranışı bırak
        if (e.ctrlKey || e.metaKey || e.shiftKey) return;
        e.preventDefault();
        openPlayer(item);
    };

    return (
        <div className={"short container"}>
            <div className={"short-header-title"}>OBBTV HABERLER</div>

            {loading && <div className={"short-loading"}>Yükleniyor...</div>}
            {error && <div className={"short-error"}>{error}</div>}

            <div className={"shorts"}>
                {items.length === 0 && !loading ? (
                    <div className={"short-empty"}>Kısa video bulunamadı.</div>
                ) : (
                    items.map((item, idx) => (
                        <a
                            key={item.id || idx}
                            className={"short-item"}
                            href={getUrl(item)}
                            onClick={(e) => handleClick(e, item)}
                            target={getUrl(item) === "#" ? undefined : "_blank"}
                            rel={getUrl(item) === "#" ? undefined : "noopener noreferrer"}
                            aria-label={item?.title || "Short video"}
                        >
                            <div className={"short-item-thumb"} role="img" aria-hidden="true">
                                <img src={getThumbnail(item)} alt={item?.title || "thumbnail"} loading="lazy" />
                                <div className={"play-icon"} />
                            </div>

                            <div className={"short-item-body"}>
                                <div className={"short-item-title"}>
                                    {item?.title || "Başlıksız video"}
                                </div>
                                <div className={"short-item-sub"}>{item?.id}</div>
                            </div>
                        </a>
                    ))
                )}
            </div>

            {/* Modal oynatıcı */}
            {selected && (
                <div className="short-modal-overlay" onClick={closePlayer}>
                    <div className="short-modal" onClick={(e) => e.stopPropagation()}>
                        <button className="short-modal-close" onClick={closePlayer} aria-label="Kapat">×</button>
                        <div className="short-modal-body">
                            <iframe
                                title={selected.title || 'YouTube Player'}
                                src={getEmbedUrl(selected)}
                                width="100%"
                                height="100%"
                                style={{ border: 0 }}
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default ObbTvHaberPage;
